import type {ReactElement} from 'react';
import {CircularProgressLoader, LOADER_SIZE} from '@Components/circular-progress-loader';
import type {PreviewLoadingContentProps} from './preview-loading-content.types';

export function PreviewLoadingContent({isLoading, loadingPlaceholder, contentClasses = '', children}: PreviewLoadingContentProps): ReactElement {
  const getLoadingIndicator = (): ReactElement | null => {
    if (!loadingPlaceholder) {
      return <CircularProgressLoader classes={isLoading ? '_position-absolute' : '_hidden'} size={LOADER_SIZE.MEDIUM} />;
    }

    return isLoading ? loadingPlaceholder : null;
  };

  return (
    <>
      {getLoadingIndicator()}
      <div className={`_full-width ${contentClasses} ${isLoading ? '_invisible' : ''}`}>{children}</div>
    </>
  );
}
